module.exports = __webpack_public_path__ + "static/media/mood-tarot.b1b22695.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/mood-tarot.png
// module id = 1556
// module chunks = 0